import React from 'react';
import T from 'prop-types';
import { withNamespaces } from 'react-i18next';

import { footerLinks } from 'constants/links';

import Social from '../Social';
import './styles.scss';

const Academy = {
  group: 'academy',
  links: [
    {
      label: 'buyBitcoin',
      href: 'buy-bitcoin',
    },
  ],
};

const FooterNavigationView = ({
  data, isWhite, t, i18n, liquidStatus, operating,
}) => {
  const { opening, closed, zone } = operating;
  return (
    <div className="footer-navigation__wrap">
      <div className={`row footer-navigation footer-navigation--${i18n.language}`}>
        {data.map((item, index) => {
          return (
            <div key={index} className={`${item.group === 'company' && 'mobileResponsive'}`}>
              <div
                className={`footer-navigation__group footer-navigation__group--${i18n.language}`}
              >
                {item.group === 'features' &&
                  <div className="footer-navigation__indicator" />
                }
                <span>{t(`components.Footer.Navigation.${item.group}`)}</span>
              </div>
              <ul className="footer-navigation__links">
                {item.links.map(link => {
                  if (link.label === 'contactUs') {
                    return (
                      <li
                        key={link.label}
                        className="footer-navigation__link"
                      >
                        <a
                          target="_bank" rel="noopener nofollow noreferrer"
                          href="mailto:support@liquid.com"
                        >
                          {t(`components.Footer.Navigation.${link.label}`)}
                        </a>
                      </li>
                    );
                  }
                  let href = footerLinks(i18n.language)[link.href];
                  if (link.fromApi) {
                    href = link.href;
                  }
                  if (i18n.language !== 'en' && link.label === 'mobileApp') {
                    return null;
                  }

                  const indicatorStyle = (liquidStatus && link.label === 'status')
                    ? `footer-navigation__indicator__${liquidStatus}`
                    : '';

                  return (
                    <li
                      key={link.label}
                      className={`footer-navigation__link footer-navigation__link--${i18n.language} ${link.label === 'status' ? 'footer-navigation__status' : ''}`}
                    >
                      {link.label === 'status' &&
                        <div className={`footer-navigation__indicator ${indicatorStyle}`} />
                      }
                      {href.indexOf('http') !== -1 && link.type === 'term-and-condition' && t('components.Footer.Navigation.TermsOfUse') ? (
                        <a rel="noopener nofollow noreferrer" target="_blank" href={t('components.Footer.Navigation.TermsOfUse')}>
                          {t(`components.Footer.Navigation.${link.label}`)}
                        </a>
                      ) : href.indexOf('http') !== -1 && link.type === 'risks' && t('components.Footer.Navigation.RiskDisclosure') ? (
                        <a rel="noopener nofollow noreferrer" target="_blank" href={t('components.Footer.Navigation.RiskDisclosure')}>
                          {t(`components.Footer.Navigation.${link.label}`)}
                        </a>
                      ) : href.indexOf('http') !== -1 ? (
                        <a rel="noopener nofollow noreferrer" target="_blank" href={href}>
                          {t(`components.Footer.Navigation.${link.label}`)}
                        </a>
                      ) : (
                        <a href={href}>
                          {t(`components.Footer.Navigation.${link.label}`)}
                        </a>
                      )}
                    </li>
                  );
                })}
              </ul>
              {index === 0 && (
                <div
                  className={`footer-navigation__group footer-navigation__subcolumn footer-navigation__group--${i18n.language}`}
                >
                  {item.group === 'features' &&
                    <div className="footer-navigation__indicator" />
                  }
                  <span>{t(`components.Footer.Navigation.${Academy.group}`)}</span>
                </div>
              )}
              {index === 0 && (
                <ul className="footer-navigation__links">
                  {Academy.links.map(link => {
                    const href = footerLinks(i18n.language)[link.href];
                    return (
                      <li
                        key={link.label}
                        className={`footer-navigation__link footer-navigation__link--${i18n.language}`}
                      >
                        {href.indexOf('http') !== -1 ? (
                          <a rel="noopener nofollow noreferrer" target="_blank" href={href}>
                            {t(`components.Footer.Navigation.${link.label}`)}
                          </a>
                        ) : (
                          <a href={href}>
                            {t(`components.Footer.Navigation.${link.label}`)}
                          </a>
                        )}
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          );
        })}
        <div className="footer-navigation__lang">
          <div className="mobileResponsive">
            <p className="footer-navigation__follow">
              {t('components.Footer.Navigation.FollowUsOn')}
            </p>
            <Social isWhite={isWhite} />
          </div>
          <div className="mobileResponsive footer-navigation__subcolumn footer-navigation__link footer-navigation__wide">
            <a
              target="_bank" rel="noopener nofollow noreferrer"
              href="mailto:support@liquid.com"
              className="footer-navigation__follow"
            >
              {t('components.Footer.Navigation.CustomerSupport')}
            </a>
          </div>
          <div className="mobileResponsive">
            <p className="footer-navigation__follow">
              {t('components.Footer.Navigation.OfficeBusinessHours')}
            </p>
            <span className="footer-navigation__link footer-navigation__wide">
              {t('components.Footer.Navigation.hours', { opening, closed, zone })}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

FooterNavigationView.propTypes = {
  logo: T.oneOfType([T.shape({}), T.string]),
  width: T.number,
  data: T.arrayOf(T.shape({})),
  isWhite: T.bool,
  liquidStatus: T.string.isRequired,
};

export default withNamespaces('core')(FooterNavigationView);



// WEBPACK FOOTER //
// ../src/components/Footer/Navigation/View.jsx